<footer class="footer text-center" *ngIf="constant.IsVerified">
  <ul class="w-100 social-menu social-menu--landing social-menu--landing-glitch">
    <li>
      <a>
        <i class="fa fa-copyright glitch-layer glitch-layer--1"></i>
        <i class="fa fa-copyright glitch-layer glitch-layer--2"></i>
        <i class="fa fa-copyright"></i>
        <span class="link-subtitle">Copyright</span>Supernowa 2020
      </a>
    </li>
  </ul>
</footer>
